var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.id,"type":"text","maxlength":_vm.maxlength},domProps:{"value":_vm.text},on:{"change":_vm.change,"keypress":_vm.keypress,"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }